import reducer from './reducer'
import { createStoreTools } from '../store'
import type { TableAction } from './actions'
import type { TableState } from './types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Store = createStoreTools<TableState<any>, TableAction<any>>(reducer)
export default Store
